import React, { useState } from 'react';
import styled from 'styled-components';
import FullScreenDialog from './FullScreenDialog';
import WizardControls from './WizardControls';

const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`;

const Wizard = ({
  showWizard,
  closeWizard,
  wizardPages,
  isBackButtonVisible = true,
  componentWidth,
  hideOverflow,
  ...rest
}) => {
  const [pageIndex, setPageIndex] = useState(0);
  const [previousPageIndex, setPreviousPageIndex] = useState(-1);

  const setPageIndices = nextIndex => {
    setPageIndex(nextIndex);
    setPreviousPageIndex(pageIndex);
  };

  // In some cases we want to be able to hide the back button
  // Like when showing a loading, success or failure state
  const [areWizardControlsVisible, setWizardControlsVisible] = useState(isBackButtonVisible);
  // So we'll make these available to the children components of the wizard
  const showWizardControls = () => setWizardControlsVisible(true);
  const hideWizardControls = () => setWizardControlsVisible(false);

  const PageToRender = wizardPages.find((page, index) => index === pageIndex).component;

  return (
    <FullScreenDialog
      visible={showWizard}
      componentWidth={componentWidth}
      hideOverflow={hideOverflow}
    >
      <StyledContainer>
        {areWizardControlsVisible && (
          <WizardControls
            closeWizard={closeWizard}
            goBack={() => setPageIndices(pageIndex - 1)}
            pageIndex={pageIndex}
          />
        )}
        <PageToRender
          closeWizard={closeWizard}
          pageIndex={pageIndex}
          previousPageIndex={previousPageIndex}
          setPageIndex={setPageIndices}
          lastPageIndex={wizardPages.length - 1}
          showWizardControls={showWizardControls}
          hideWizardControls={hideWizardControls}
          {...rest}
        />
      </StyledContainer>
    </FullScreenDialog>
  );
};

export default Wizard;
